import { render } from "./EinrichtungActionComponent.vue?vue&type=template&id=50c5a307"
import script from "./EinrichtungActionComponent.vue?vue&type=script&lang=js"
export * from "./EinrichtungActionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__